import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { FormioControllerService } from "../../../../../services/form-controller/formio-controller.service";
import {PaymentFormControllerService} from "../../../../../services/form-controller/payment-form-controller.service";
import FormUtils from "../../../../utils/form-utils.component";
import {Store} from "../../../../../services/store.service";
import {BaseError} from "../../../base-error";
import {ToastrService} from "ngx-toastr";
import { environment } from "../../../../../../environments/environment";
import {BaseForm} from "../../../../../models/base-form";
import Helpers from "../../../../../utils/helpers";
import {FormControllerService} from "../../../../../services/form-controller/form-controller.service";

@Component({
  selector: "payment-form",
  templateUrl: "./payment.component.html",
  styleUrls: ["./payment.component.css"],
  providers: [PaymentFormControllerService, FormioControllerService],
})

export class PaymentComponent extends BaseError implements OnInit {

  public serviceId: string;
  @Input() public determinantMapById: { [key: string]: string };
  @Input() public paymentForm: BaseForm = new BaseForm();
  @Input() public focusCompKey?: string;
  @Output() public formReverted: EventEmitter<BaseForm> = new EventEmitter();
  public formLoaded: boolean = false;
  public activeTab: string = "form";
  public showHistory: boolean = false;

  constructor(private route: ActivatedRoute,
              public store: Store,
              public toastr: ToastrService,
              private formControllerService: FormControllerService,
              public paymentFormControllerService: PaymentFormControllerService) {
    super(toastr);
  }

  public ngOnInit() {
    this.route.params.subscribe((params) => {
      this.serviceId = params.serviceId;
      this.store.state.common.applicantFormPage.set("payment");
    });
  }

  public notifyTabChange(newtab: string): void {
    this.activeTab = newtab;
  }

  public saveTutorial(e) {
    if (e) {
      this.paymentForm.tutorials.general = e;
      this.saveForm(this.paymentForm.formSchema);
    }
  }

  public saveForm(formSchema: any) {
    if (this.paymentForm.id) {
      // add version to distinguish old and new form builder components
      if (formSchema && formSchema.components) {
        for (const comp of formSchema.components) {
          FormUtils.updateWithVersion(comp);
          FormUtils.updateTableAttributes(comp);
        }
      }
    }
    this.paymentForm.formSchema = formSchema;
    if (this.paymentForm.id) {
      this.paymentFormControllerService.savePaymentForm(this.paymentForm).subscribe(
          () => undefined,
          (error) => this.showErrorMessage(error),
      );
    } else {
      this.paymentFormControllerService.createPaymentForm(this.serviceId, this.paymentForm).subscribe(
        (data) => {
          this.paymentForm = (data ? data : this.paymentForm);
        },
      );
    }
  }

  public openHistory() {
    this.showHistory = true;
  }

  public closeHistory() {
    this.showHistory = false;
  }

  public changeForm(revisionNumber: string): void {
    if (revisionNumber) {
      // Step 1: GET the schema for validation
      this.paymentFormControllerService.getFormSchemaForRevision(this.serviceId, revisionNumber).subscribe((schema) => {
        if (schema) {
          // Step 2: Validate schema for duplicate keys
          const result = Helpers.validateFormSchema(schema);
          if (Array.isArray(result) && result.length > 0) {
            this.error("Please reload page!\n" + Helpers.generateValidationErrorMessages(result).join("\n"), 'Validation error');
          }
          else {
            // Step 3: If valid, call PUT to revert (triggers cleanup of orphaned relations)
            this.paymentFormControllerService.revertFormToRevision(this.serviceId, revisionNumber).subscribe(
              () => {
                // Step 4: Reload the form after successful reversion
                this.paymentFormControllerService.getPaymentForm(this.serviceId, false).subscribe(
                  (data) => {
                    this.paymentForm = data ? data : this.paymentForm;
                    this.formReverted.emit(this.paymentForm);
                    this.responseSuccessful("Form reverted successfully");
                  },
                  (error) => this.showErrorMessage(error)
                );
              },
              (error) => this.showErrorMessage(error)
            );
          }
        }
      });
    }
  }

  public downloadSchema() {
    this.formControllerService.downloadSchemaWithRelations(this.paymentForm.id).subscribe(
      (data) => {
        const blob = new Blob([data], { type: "application/octet-stream" });
        const downloadURL = window.URL.createObjectURL(data);
        const link = document.createElement("a");
        link.href = downloadURL;
        link.download = `${this.store.state.common.serviceName}_payment_form_schema.json`;
        link.click();
      },
      (error) => this.showErrorMessage(error),
    );
  }
}
